import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
	// 设置页面标题为路由中定义的meta字段中的title
	document.title = to.meta.title || '默认标题'
	next()
})

Vue.config.productionTip = false

new Vue({
	router,
	el: '#app',
	render: h => h(App),
}).$mount('#app')
